import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Map, Marker, GoogleApiWrapper} from 'google-maps-react';
import './Dojo.css';
import { DojoRepository } from '../data/DojoRepository';

class VilleStLaurent extends Component {
  render() {
    return (
        <div class="container page-content">
            <div id="dojoHeader">
                <img id="ShotokanLogo" alt="Logo du karaté Shotokan" src="/images/logos/Shotokan.png" />
            </div>
            <article id="dojoContent">
                <section id="dojoDescription">
                    <h1>{DojoRepository.VILLE_ST_LAURENT.name}</h1>
                    <p>Le club de karaté Kio existe depuis 1971.</p>
                    <p>Nous pratiquons un karaté traditionnel avec une pédagogie moderne. Les entraînements sont intenses et dynamiques. L'enseignement est planifié et soucieux de respecter le développement de tous les aspects du karaté.</p>
                    <p>À travers cette méthode, chacun y trouve ce qu'il recherche; approche traditionnelle, compétition, plaisir, santé et bien-être. Le plus grand atout est certainement l'esprit de famille qui unit tous les membres.</p>
                </section> 
                <p>&nbsp;</p>

                <section id="dojoTeam"> 
                    <h1>L'équipe</h1>
                    <p><strong>Instructeur en chef</strong><br />
                    Aïman Benkhadra - 3e Dan</p>

                    <p><strong>Instructeurs</strong><br />
                    Alexandre Sita - 3e Dan<br />
                    Evelyn Barrera-Fuentes - 3e Dan<br />
                    Adnane Benkhadra - 2e Dan<br />
                    Noël Ngandui - 2e Dan<br />
                    Nabil Belhaj - 2e Dan</p>
                </section> 
                <p>&nbsp;</p>

                <section id="dojoPrices"> 
                    <h1>Horaire et tarifs</h1>
                    <p>Nous vous invitons à consulter notre site web officiel pour obtenir toute l'information concernant notre offre de cours ainsi que nos tarifs&nbsp; :</p>
                    <p><a href="https://kiosaintlaurent.com/kio-saint-laurent/horaire-session-prochaine/" target="_blank" rel="noopener noreferrer" title="Horaire complet">Horaire complet</a></p>
                    <p><a href="https://kiosaintlaurent.com/kio-saint-laurent/tarifs/" target="_blank" rel="noopener noreferrer" title="Liste des tarifs">Liste des tarifs</a></p>
                </section>
                <p>&nbsp;</p>

                <section id="dojoContacts"> 
                    <h1>Pour nous joindre</h1>
                    <p>
                        <strong>{DojoRepository.VILLE_ST_LAURENT.name}</strong><br />
                        {DojoRepository.VILLE_ST_LAURENT.address.line1}<br />
                        {DojoRepository.VILLE_ST_LAURENT.address.city}<br />
                        {DojoRepository.VILLE_ST_LAURENT.address.postalCode}<br />
                        <a href={DojoRepository.VILLE_ST_LAURENT.links.googleMaps} target="_blank" rel="noopener noreferrer" title={DojoRepository.VILLE_ST_LAURENT.name}>Google Maps</a>
                    </p>
                    <p>
                        <strong>{DojoRepository.VILLE_ST_LAURENT.contact.aiman.fullName}</strong><br />
                        {DojoRepository.VILLE_ST_LAURENT.contact.aiman.phone1}<br />
                        <span class="link-like">{DojoRepository.VILLE_ST_LAURENT.contact.aiman.email1}</span><br />
                    </p>
                    <p>
                        <strong>{DojoRepository.VILLE_ST_LAURENT.contact.alexandre.fullName}</strong><br />
                        <span class="link-like">{DojoRepository.VILLE_ST_LAURENT.contact.alexandre.email1}</span><br />
                    </p>
                </section> 
                <p>&nbsp;</p>
                
                <section id="dojo-map">
                    <Map
                        google={this.props.google}
                        initialCenter={DojoRepository.VILLE_ST_LAURENT.geo}>
                        <Marker position={DojoRepository.VILLE_ST_LAURENT.geo} />
                    </Map>
                </section> 
            </article>
            <Link class="returnToDojoRepository" to="/dojo">Retour au repertoire des Dojos</Link>
        </div>
    );
  }
}

export default GoogleApiWrapper({
    apiKey: ("AIzaSyCqdJMLfuasXIr2gfxOzJyfP1gXVQt5-H8")
})(VilleStLaurent)



// WEBPACK FOOTER //
// ./src/pages/dojo/VilleStLaurent.js